import { Typography } from "@mui/material"

const HeaderSiteInfos = ({infos, className = ""}) => {
  return (
    <div className="flex flex-col align-items-center justify-center items-center hover:text-blue-800 transition-colors">
      <Typography variant="h2" className="font-bold sm:text-xl lg:text-2xl text-lg">
        {infos.name}
      </Typography>
      <Typography variant="caption" className="sm:block hidden">
        {infos.address}
      </Typography>
    </div>
  )
}

export default HeaderSiteInfos
